const PeerReview = ({participants, handleChange, error, scoreLeft, data}) => {

	let startTime = data['waktu_mulai'].split(" ")[1]
	let endTime = data['waktu_akhir'].split(" ")[1]
	return (
		<div className='peer-review-section'>
			<h3>Peer Review</h3>
			<h4 className='wiyata-blue-text peer-review-matkul'>{data['mata_kuliah']}</h4>
			<h4 className='peer-review-matkul'>{`${data['topik_diskusi']} (${startTime} - ${endTime})`}</h4>
			
			<p className='peer-review-info'>Please evaluate performance of each member in your group. 
			Divide the score equally to each member until the sum of 100 points reached.</p>
			{
				error !== null &&
				<p className='peer-review-warning'>{error}</p>
			}
			<table>
				{
					participants.length > 0 &&
					<tr>
						<th>Number</th>
						<th>Student</th>
						<th>Score</th>
					</tr>
				}
				{
					participants.map((participant, index) => {
					return (
						<tr key={index}>
							<td>{index + 1}</td>
							<td>{`${participant['nama_peserta']} - ${participant['npm_peserta']}`}</td>
							<td>
								<input
									name='score'
									placeholder='Tulis Penilaian'
									type='number'
									value={participant.score}
									onChange={event => handleChange(index, event)}
									min={0}
									className='peer-review-input'
								/>
							</td>
						</tr>
					)
					})
				}
			</table>
			<p className='peer-review-warning'>{`*You have remaining ${scoreLeft} points to transmit.`}</p>
		</div>
	);
}
 
export default PeerReview;